


































import _ from 'lodash'
import { Component, Prop } from 'vue-property-decorator'
import BaseInput from '@/services/BaseInput'

@Component
export default class Textarea extends BaseInput {
  @Prop({ default: 'transparent' }) public backgroundColor!: string
  @Prop({ default: '4' }) public rowsAmount!: string

  public onEmitEvent(ev) {
    this.$emit('event', ev, this.name)
  }
}
